/**
 * @file Manages the navigation storage in local storage
 */

export type SelectedStore = {
  storeId: string;
  storeName: string;
};

/**
 * Get the current Nav
 */
export function get(): SelectedStore | null {
  const selectedstore = window.localStorage.getItem('selectedstore');

  if (selectedstore) {
    return JSON.parse(selectedstore);
  }

  return null;
}

/**
 * Set the store
 *
 * @param store
 */
export function set(store: SelectedStore) {
  window.localStorage.setItem('selectedstore', JSON.stringify(store));
}

/**
 * Remove the nav
 */
export function remove() {
  window.localStorage.removeItem('selectedstore');
}
